import config from '@/shared/config'

let appConfig = {
  install(Vue: any, options: any) {
    let moduleConfigs = {}
    if ('modules' in options) {
      moduleConfigs = options['modules'].reduce((prev: any, module: string) => {

          try {
            const Module = require(`@/modules/${module}/config`)
            return {
              ...prev,
              ...Module['default']
            }

          } catch (err) {
            console.error(`Error on Load Module  ${module} Config`)
            console.error(err)
            return prev
          }
        }
      ,moduleConfigs)
    }

    Vue.prototype.$config = {
      ...config,
      ...options,
      ...moduleConfigs
    }
  }
}

export default appConfig;

